import { Box, Grid, Modal, Popover, Typography } from '@mui/material';
import dayjs from 'dayjs';
import React, { useContext, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { AppContext } from '@/utils/appContext';
import { useTranslation } from 'react-i18next';
import { ModalDatePicker } from '../modal/ModalDatePicker';
import {
  ArrowRight,
  CalendarDots
} from '@vectopus/atlas-icons-react';
import {useResponsive} from "@/hooks/use-responsive";
import {website} from "@/utils/helpers";

const SelectDateField = (props: any) => {

  // console.count('SelectDateField')

  const modal = {
    backgroundColor: '#FFF',
    '.MuiBackdrop-root': {
      backgroundColor: '#FFF'
    }
  };

  const modalInsideDrawer = {
    width: 470,
    left: 'inherit',
    backgroundColor: '#FFF',
    overflow: 'hidden',
    '.MuiBackdrop-root': {
      display: 'none!important'
    }
  }

  const appContext = useContext(AppContext);
  const { classes } = useStyles();
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [openModalDatePicker, setOpenModalDatePicker] = useState(false);
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
    setOpenModalDatePicker(true);
  };
  const handleCloseModalDatePicker = () => {
    setOpenModalDatePicker(false);
  };


  const upMd = useResponsive('up', 'md');
  const downMd = useResponsive('down', 'md');

  const container = props.params.container;

  return (
    <>
      <Grid
        size={{ xs: "grow", sm: "auto", md: website.properties.length !== 1 ? 3 : 4 , lg: website.properties.length !== 1 ? 3 : 4 } as const}
        className={classes.inputPaper}
        id="grid-daterangepicker"
        sx={{ width: container === "DrawerSearchWidget" ? "100%!important" : "initial" }}
        onClick={(event: any) => handlePopoverOpen(event)}>
        <Box
          id={'fieldContent'}
          className={
            (props.params && props.params.container === 'SearchBarMobile')
              ? classes.fieldContent
              : classes.fieldContent2
          }>
          <>
            {
              container !== 'DrawerSearchWidget' && (
                <Box pr={1} sx={{ height: 24 }}>
                  <CalendarDots size={20} />
                </Box>
              )
            }

            { !dayjs(appContext.searchForms[appContext.orderIndex].GuestArrival).isValid() ? (
              <Typography variant={'h6'} component={'h6'}>
                {t('Data di arrivo')}
              </Typography>
            ) : (
              <Typography variant={'h6'} component={'h6'} sx={{ color: '#000!important' }}>
                {dayjs(appContext.searchForms[appContext.orderIndex].GuestArrival).format('DD/MM/YY')}
              </Typography>
            )}

            <Box pr={1} pl={1} display={'flex'}>
              <ArrowRight size={12} color={'#9B9B9B'} />
            </Box>

            {!dayjs(appContext.searchForms[appContext.orderIndex].GuestDeparture).isValid() ? (
              <Typography variant={'h6'} component={'h6'}>
                {t('Data di partenza')}
              </Typography>
            ) : (
              <Typography variant={'h6'} component={'h6'} sx={{ color: '#000!important' }}>
                {dayjs(appContext.searchForms[appContext.orderIndex].GuestDeparture).format('DD/MM/YY')}
              </Typography>
            )}
          </>

          {
            container === 'DrawerSearchWidget' && (
              <Box pr={1} sx={{ position: 'absolute', right: 5, display: 'flex', alignItems: 'center' }}>
                <CalendarDots size={20} />
              </Box>
            )
          }

        </Box>
      </Grid>

      {
        downMd && (
          <Modal
              open={openModalDatePicker}
              onClose={handleCloseModalDatePicker}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              sx={modal}>
            <ModalDatePicker
              params={{
                container,
                handleCloseModalDatePicker
              }}
            />
          </Modal>
          )
      }

      {
        upMd && container === 'DrawerSearchWidget' && (
          <Modal
            open={openModalDatePicker}
            onClose={handleCloseModalDatePicker}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={modalInsideDrawer}>
            <ModalDatePicker
              params={{
                container,
                handleCloseModalDatePicker
              }}
            />
          </Modal>
        )
      }

      {
        upMd && container !== 'DrawerSearchWidget' && (
          <Popover
            onClose={handleCloseModalDatePicker}
            open={openModalDatePicker}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
            className={classes.popoverContainer}>
            <ModalDatePicker
              params={{
                container,
                openModalDatePicker,
                handleCloseModalDatePicker
              }}
            />
          </Popover>
        )
      }
    </>
  );
};

export default SelectDateField;


const useStyles = makeStyles()((theme) => {
  return {
    fieldContent: {
      backgroundColor: '#f5f5f5!important',
      padding: '16px 12px',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderRadius: theme.radius.formBorderRadius,
      cursor: 'pointer',
      i: {
        fontSize: 26
      }
    },
    fieldContent2: {
      backgroundColor: '#f5f5f5',
      position: 'relative',
      padding: '16px 12px',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderRadius: theme.radius.formBorderRadius,
      cursor: 'pointer',
      i: {
        fontSize: 26
      },
      [theme.breakpoints.down('md')]: {
        backgroundColor: '#fff!important'
      }
    },
    inputPaper: {
      backgroundColor: '#FFF',
      borderRadius: theme.radius.formBorderRadius,
      whiteSpace: 'nowrap',
      cursor: 'pointer',
      /*width: '100%!important',
      maxWidth: '100%!important',*/
      h6: {
        fontSize: 14,
        /*fontFamily: theme.typography.h2.fontFamily,*/
        color: '#9B9B9B'
      },
      '.las.la-arrow-right': {
        color: '#9B9B9B',
        fontSize: 16
      }
    },
    popoverContainer: {
      '.MuiPopover-paper': {
/*
        width: 400,
*/
        height: 'fit-content'
      },
      '& .MuiBackdrop-root': {
        backgroundColor: '#000000',
        opacity: '0.4!important'
      }
    }
  };
});
